import { render } from "./ActivityLogChangeDetail.vue?vue&type=template&id=78d50ae3"
import script from "./ActivityLogChangeDetail.vue?vue&type=script&lang=js"
export * from "./ActivityLogChangeDetail.vue?vue&type=script&lang=js"

import "./ActivityLogChangeDetail.vue?vue&type=style&index=0&id=78d50ae3&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__